export const UnAuthenticatedRoutes = [
    'CONTACT',
    'SIGN_IN',
    'PRIVACY_POLICY',
    'TERMS_CONDITION',
    'COOKIE_POLICY',
    'FAIR_PLAY_POLICY',
    'FAQS',
    'REQUEST_ACCOUNT_DELETION',
] as const;

export const AuthenticatedRoutes = [
    'HOME',

    'DASHBOARD',
    'INSIGHTS',
    'USER_INSIGHTS',

    'PAYMENTS',

    'CATEGORY',

    'DEVELOPER',

    'BLOCKED_USERS',

    'GAMES',
    'ADD_GAMES',
    'VIEW_GAMES',
    'EDIT_GAMES',

    'LEAGUES',
    'ADD_LEAGUES',
    'EDIT_LEAGUES',

    'KNOCKOUT',
    'ADD_KNOCKOUT',
    'EDIT_KNOCKOUT',

    'ROOMS',

    'USERS',
    'USERS_DETAILS',
    'USERS_LOGS',
    'TRACKER',
    'STREAKS',
    'SUBSCRIPTIONS',
    'SUBSCRIBERS',

    'SETTINGS',
] as const;

export type AuthenticatedRoutesType = typeof AuthenticatedRoutes[number];
export type UnAuthenticatedRoutesType = typeof UnAuthenticatedRoutes[number];

export type RoutesType = AuthenticatedRoutesType | UnAuthenticatedRoutesType;
